import { ChangeDetectionStrategy, Component, Input, HostBinding } from '@angular/core';

@Component({
    selector: 'ppl-top-navigation-button',
    templateUrl: './top-navigation-button.component.html',
    styleUrls: ['./top-navigation-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TopNavigationButtonComponent {

  @Input() @HostBinding('class.disabled') disabled = false;
}
